<template>
  <panel title='登陆失败'>
    <div class="d-flex" middle center style='height:100%;'>
      <div class="tcenter">
        <div class="f-place mb-20">
          {{ $config.error || "服务维护中,请稍后在尝试..." }},
        </div>
        <button class="sd-btn btn-primary" round @click='gohome'>返回首页</button>
      </div>
    </div>
  </panel>
</template>
<script>
export default {
  methods: {
    gohome() {
      this.$config.error = '';
      this.$router.push("/");
    }
  }
}
</script>
<style lang='less'></style>
